import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle, CardDescription, CardFooter } from '@/components/ui/card';
import { Info } from 'lucide-react';

interface ErrorStateProps {
  error: string;
  onRetry: () => void;
}

/**
 * Component to display an error state
 */
export const ErrorState: React.FC<ErrorStateProps> = ({ error, onRetry }) => {
  return (
    <div className="container max-w-7xl mx-auto py-6 px-6">
      <Card className="border-destructive shadow-md">
        <CardHeader>
          <CardTitle className="flex items-center text-destructive">
            <Info className="mr-2 h-5 w-5" />
            Loading Error
          </CardTitle>
          <CardDescription className="mt-2">{error}</CardDescription>
        </CardHeader>
        <CardFooter className="flex justify-end border-t pt-4">
          <Button onClick={onRetry}>
            Retry
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default ErrorState;
